import { TFunction } from 'i18next'

import { tExcesses, tFormats } from '../../../../../infrastructure/internationalisation'
import { ExcessCombination } from '../../../../../state/configuration'

export const textGenerator = (t: TFunction) => (excess: ExcessCombination) =>
  Object.entries(excess)
    .map(([excessCode, excess]) => {
      const name = t(tExcesses(excessCode, 'name'))
      const amount = t(tFormats('currency.short'), { amount: excess })
      return `${name} ${amount}`
    })
    .join(' / ')
